import React from "react";

// Fix for default marker icon

const MapComponent = () => {
  return (
    <section className="container mb-20">
      <iframe
        title="205/2A Ostwal ornate, Jesal Park, Bhayander - E, 401105- Thane, Maharashtra."
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3765.2763518686716!2d72.85193657425809!3d19.313810944465608!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7afd59dafc3a5%3A0x59a04ec3d77b718f!2sOstwal%20Ornate%2C%20Jesal%20Park%20Rd%2C%20Bhayandar%2C%20Jesal%20Park%2C%20Bhayandar%20East%2C%20Mira%20Bhayandar%2C%20Maharashtra%20401105!5e0!3m2!1sen!2sin!4v1733156263037!5m2!1sen!2sin"
        width="600"
        height="450"
        style={{ border: "0px", width: "100%" }}
        allowFullScreen=""
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
      ></iframe>
    </section>
  );
};

export default MapComponent;
